enum BIEventType {

    DepositAttempt = "DepositAttempt",
    DepositFailedUI = "Deposit Failed UI"
}

export {
    BIEventType
};
